import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getParentPosition } from '../utility/dom-helpers'
import { throws } from 'assert';

class ScrollElement extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    traditionalZoom: PropTypes.bool.isRequired,
    scrollRef: PropTypes.func.isRequired,
    isInteractingWithItem: PropTypes.bool.isRequired,
    onZoom: PropTypes.func.isRequired,
    onWheelZoom: PropTypes.func.isRequired,
    onScroll: PropTypes.func.isRequired
  }

  constructor() {
    super()
    this.state = {
      isDragging: false,
      isSelecting: false,
      selectStartPositionX: 0,
      selectStartPositionY: 0,
      selectEndPositionX: 0,
      selectEndPositionY: 0,
    }
  }

  refHandler = el => {
    this.scrollComponent = el
    this.props.scrollRef(el)
  }

  handleScroll = () => {
    const scrollX = this.scrollComponent.scrollLeft
    this.props.onScroll(scrollX)
  }

  handleWheel = e => {
    const { traditionalZoom } = this.props

    // zoom in the time dimension
    if (e.ctrlKey || e.metaKey || e.altKey) {
      const parentPosition = getParentPosition(e.currentTarget)
      const xPosition = e.clientX - parentPosition.x

      const speed = e.ctrlKey ? 10 : e.metaKey ? 3 : 1

      // convert vertical zoom to horiziontal
      this.props.onWheelZoom(speed, xPosition, e.deltaY)
    } else if (e.shiftKey) {
      // shift+scroll event from a touchpad has deltaY property populated; shift+scroll event from a mouse has deltaX
      this.scrollComponent.scrollLeft += e.deltaY || e.deltaX

      // no modifier pressed? we prevented the default event, so scroll or zoom as needed
    } else {
      if (e.deltaX !== 0) {
        if (!traditionalZoom) {
          this.scrollComponent.scrollLeft += e.deltaX
        }
      }
      if (e.deltaY !== 0) {
        window.scrollTo(window.pageXOffset, window.pageYOffset + e.deltaY)
        if (traditionalZoom) {
          const parentPosition = getParentPosition(e.currentTarget)
          const xPosition = e.clientX - parentPosition.x

          this.props.onWheelZoom(10, xPosition, e.deltaY)
        }
      }
    }
  }

  handleMouseDown = e => {
    if (e.button === 0) {
      this.dragStartPosition = e.pageX
      this.dragLastPosition = e.pageX
      this.setState({
        isDragging: true
      })
    }
    else if (e.button === 2) {
      e.preventDefault();
      e.stopPropagation();

      if (this.props.dragSelectAllowed) {
        this.setState({
          isSelecting: true
        });
      }

      return false; 
    }
  }

  handleMouseMove = e => {
    // this.props.onMouseMove(e)
    //why is interacting with item important?
    if (this.state.isDragging && !this.props.isInteractingWithItem) {
      this.scrollComponent.scrollLeft += this.dragLastPosition - e.pageX
      this.dragLastPosition = e.pageX
    }

    if (this.state.isSelecting) {
      const parentPosition = getParentPosition(e.currentTarget)
      const xPosition = e.clientX - parentPosition.x + this.props.width;
      const yPosition = e.clientY - parentPosition.y;

      if (this.state.selectStartPositionX === 0 && this.state.selectStartPositionY === 0) {
        this.setState({
          selectStartPositionX: xPosition,
          selectStartPositionY: yPosition
        });
      }
      else {
        this.setState({
          selectEndPositionX: xPosition,
          selectEndPositionY: yPosition
        });
      }
    }
  }

  handleMouseUp = e => {
    this.dragStartPosition = null
    this.dragLastPosition = null
    
    this.setState({
      isDragging: false,
      isSelecting: false,
      selectStartPositionX: 0,
      selectStartPositionY: 0,
      selectEndPositionX: 0,
      selectEndPositionY: 0,
    });

    if (e.button === 2) {
      let positions = {
        startX: this.state.selectStartPositionX,
        startY: this.state.selectStartPositionY,
        endX: this.state.selectEndPositionX,
        endY: this.state.selectEndPositionY,
      }
  
      this.props.makeDragSelection(positions);
    }
  }

  handleMouseLeave = () => {
    // this.props.onMouseLeave(e)
    this.dragStartPosition = null
    this.dragLastPosition = null
    this.setState({
      isDragging: false,
    });

    if (this.state.isSelecting) {
      this.setState({
        isSelecting: false,
        selectStartPositionX: 0,
        selectStartPositionY: 0,
        selectEndPositionX: 0,
        selectEndPositionY: 0,
      });

      let positions = {
        startX: this.state.selectStartPositionX,
        startY: this.state.selectStartPositionY,
        endX: this.state.selectEndPositionX,
        endY: this.state.selectEndPositionY,
      }
      
      this.props.makeDragSelection(positions);
    }
  }

  handleTouchStart = e => {
    if (e.touches.length === 2) {
      e.preventDefault()

      this.lastTouchDistance = Math.abs(
        e.touches[0].screenX - e.touches[1].screenX
      )
      this.singleTouchStart = null
      this.lastSingleTouch = null
    } else if (e.touches.length === 1) {
      e.preventDefault()

      let x = e.touches[0].clientX
      let y = e.touches[0].clientY

      this.lastTouchDistance = null
      this.singleTouchStart = { x: x, y: y, screenY: window.pageYOffset }
      this.lastSingleTouch = { x: x, y: y, screenY: window.pageYOffset }
    }
  }

  handleTouchMove = e => {
    const { isInteractingWithItem, width, onZoom } = this.props
    if (isInteractingWithItem) {
      e.preventDefault()
      return
    }
    if (this.lastTouchDistance && e.touches.length === 2) {
      e.preventDefault()
      let touchDistance = Math.abs(e.touches[0].screenX - e.touches[1].screenX)
      let parentPosition = getParentPosition(e.currentTarget)
      let xPosition =
        (e.touches[0].screenX + e.touches[1].screenX) / 2 - parentPosition.x
      if (touchDistance !== 0 && this.lastTouchDistance !== 0) {
        onZoom(this.lastTouchDistance / touchDistance, xPosition / width)
        this.lastTouchDistance = touchDistance
      }
    } else if (this.lastSingleTouch && e.touches.length === 1) {
      e.preventDefault()
      let x = e.touches[0].clientX
      let y = e.touches[0].clientY
      let deltaX = x - this.lastSingleTouch.x
      let deltaX0 = x - this.singleTouchStart.x
      let deltaY0 = y - this.singleTouchStart.y
      this.lastSingleTouch = { x: x, y: y }
      let moveX = Math.abs(deltaX0) * 3 > Math.abs(deltaY0)
      let moveY = Math.abs(deltaY0) * 3 > Math.abs(deltaX0)
      if (deltaX !== 0 && moveX) {
        this.scrollComponent.scrollLeft -= deltaX
      }
      if (moveY) {
        window.scrollTo(
          window.pageXOffset,
          this.singleTouchStart.screenY - deltaY0
        )
      }
    }
  }

  handleTouchEnd = () => {
    if (this.lastTouchDistance) {
      this.lastTouchDistance = null
    }
    if (this.lastSingleTouch) {
      this.lastSingleTouch = null
      this.singleTouchStart = null
    }
  }

  render() {
    const { width, height, children } = this.props
    const { isDragging } = this.state

    const scrollComponentStyle = {
      width: `${width}px`,
      height: `${height + 20}px`, //20px to push the scroll element down off screen...?
      cursor: isDragging ? 'move' : 'default',
      position: 'relative'
    }

    const selectionStartX = this.state.selectStartPositionX;
    const selectionStartY = this.state.selectStartPositionY;
    const selectionEndX = this.state.selectEndPositionX;
    const selectionEndY = this.state.selectEndPositionY;

    const mWidth = Math.abs(Math.min(selectionStartX - selectionEndX, selectionEndX - selectionStartX));
    const mHeight = Math.abs(Math.min(selectionStartY - selectionEndY, selectionEndY - selectionStartY));
    const mLeft = Math.min(selectionStartX, selectionEndX);
    const mTop = Math.min(selectionStartY, selectionEndY);
    const shouldShowSelectionBox = mLeft > 0 && mTop > 0;

    return (
      <div
        ref={this.refHandler}
        data-testid="scroll-element"
        className="rct-scroll"
        onContextMenu={(e) => {e.stopPropagation(); e.preventDefault();}}
        style={scrollComponentStyle}
        onScroll={this.handleScroll}
        onWheel={this.handleWheel}
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        onMouseUp={this.handleMouseUp}
        onMouseLeave={this.handleMouseLeave}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
      >
      {this.state.isSelecting && shouldShowSelectionBox && 
        <div
          className="selectionBox"
          style={{
            minWidth: `${mWidth}px`,
            minHeight: `${mHeight}px`,
            left: `${mLeft}px`,
            top: `${mTop}px`,
            position: "absolute",
            zIndex: 90,
          }}
        ></div>
      }
        {children}
      </div>

    )
  }
}

export default ScrollElement
